import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { CatalogClient } from 'src/app/api/clients/catalogs';
import { MerchantCatalog } from 'src/app/api/openapi';

const SelectCatalog = ({
  selectedMerchantId,
  selectedCatalogId,
  setSelectedCatalogId,
}: any) => {
  const [catalogs, setCatalogs] = useState<MerchantCatalog[]>([]);
  const cursor = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!selectedMerchantId) return;
    CatalogClient.listMerchantCatalogs(
      selectedMerchantId,
      'name',
      10,
      cursor.current
    ).then(({ data }) => {
      cursor.current = data.cursor;
      setCatalogs(data?.items || []);
    });
  }, [cursor]);

  return (
    <FormControl>
      <InputLabel id="select-catalog">Select a Catalog</InputLabel>
      <Select
        value={selectedCatalogId}
        onChange={({ target }) => setSelectedCatalogId(target.value)}
        labelId="select-catalog"
        sx={{ minWidth: 200 }}
      >
        {catalogs.map((catalog) => (
          <MenuItem value={catalog.id}>{catalog.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectCatalog;
